// Slim entrypoint for the public wiki pages on the apex hosts (ApplicationHelper#slim_wiki_head?).
// Loads ONLY what an anonymous visitor's wiki page uses: the header/footer controllers, the
// consent banner and the table of contents. No Turbo, so every link is a full page load from
// the edge cache; no ActiveStorage, lexxy, Pagy or the full controller set of application.js.
// A controller those pages start using must be registered below as well:
// spec/requests/public_wiki_pages_stimulus_spec.rb renders every brand's kinds of wiki page and
// fails on a data-controller (or data-action) that is not.
//
// Not landing.js: that one fires "Funnel: Landing Page" on every load and runs the drv.ge
// ka-banner experiment, so a wiki view would count as a landing view.

// Frontend error reporting, with the Sentry SDK fetched only on the first error. First, so its
// listeners are in place before the controllers run.
import "./sentry_on_error"

import { Application } from "@hotwired/stimulus"
import MobileMenuController from "./controllers/mobile_menu_controller"
import DropdownController from "./controllers/dropdown_controller"
import CollapseController from "./controllers/collapse_controller"
import ConsentBannerController from "./controllers/consent_banner_controller"
import WikiTocController from "./controllers/wiki_toc_controller"

const application = Application.start()
application.register("mobile-menu", MobileMenuController)
application.register("dropdown", DropdownController)
application.register("collapse", CollapseController)
// Non-modal cookie-consent banner (zones with the Zaraz consent modal off).
application.register("consent-banner", ConsentBannerController)
application.register("wiki-toc", WikiTocController)
